import { render, staticRenderFns } from "./HomeSteps.vue?vue&type=template&id=2cccdc72&scoped=true&"
import script from "./HomeSteps.vue?vue&type=script&lang=js&"
export * from "./HomeSteps.vue?vue&type=script&lang=js&"
import style0 from "./HomeSteps.vue?vue&type=style&index=0&id=2cccdc72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cccdc72",
  null
  
)

export default component.exports